import React from "react";
import { Box, Card, Grid, Button } from "@mui/material";

import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import ChevronDownIcon from "@mui/icons-material/KeyboardArrowDown";


import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  PieChart,
  Pie,
  Cell,
  CartesianGrid
} from "recharts";
import { useNavigate } from "react-router-dom";
export interface KpiDonutItem {
  label: string;
  value: number;
  unit: string;
  trend: number;          // positive / negative change
  trendLabel: string;     // small text below value
  color: string;          // active arc
  bg: string;             // remaining arc
}

const performanceData = [
  { name: "Apr 26", a: 7000, b: 8000, c: 4000 },
  { name: "Apr 25", a: 12000, b: 10000, c: 6000 },
  { name: "May 25", a: 18000, b: 15000, c: 9000 },
  { name: "May 19", a: 28000, b: 22000, c: 14000 },
  { name: "May 19", a: 32000, b: 26000, c: 16000 },
  { name: "May 19", a: 36000, b: 30000, c: 18000 },
  { name: "May 21", a: 42000, b: 35000, c: 11000 }
];

const planChartData = [
  { name: "Basic", value: 46, color: "#22c55e" },
  { name: "Standard", value: 38, color: "#3b82f6" },
  { name: "Premium", value: 16, color: "#f59e0b" },
];

const roiData = [
  { name: "Savings", value: 305.8 },
  { name: "Cost", value: 42.6 },
];

export const kpiDonutData: KpiDonutItem[] = [
  {
    label: "Success Rate",
    value: 96.8,
    unit: "%",
    trend: +1.4,
    trendLabel: "↑ 1.4%",
    color: "#4caf50",
    bg: "#e8f5e9",
  },
  {
    label: "Autonomy Level",
    value: 44,
    unit: "%",
    trend: +3.1,
    trendLabel: "↑ 3.1%",
    color: "#26c6da",
    bg: "#e0f7fa",
  },
  {
    label: "Avg. Latency",
    value: 780,
    unit: "ms",
    trend: -4.9,
    trendLabel: "↓ 4.9%",
    color: "#ff9800",
    bg: "#fff3e0",
  },
  {
    label: "Most Failbacks",
    value: 7,
    unit: "%",
    trend: +2.1,
    trendLabel: "↑ 2.1",
    color: "#9c27b0",
    bg: "#f3e5f5",
  },
];


export default function PricingAnalytics() {
  const navigate = useNavigate();
  return (
    <><div className="main_title ai_command_page d_flex">
      <div className="lt">
        <h1>Pricing Analytics</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Pricing Analytics
        </p>
      </div>


    </div><div className="gap_m">
        {/* ================= STATS ================= */}
        <div className="w_100 cards">
          <div className="stats_boxes  gap_m">
            {/* Total Revenue */}
            <a className="cards" style={{ backgroundColor: "#DFF3EE" }}>
              <div className="data_top">
                <h2>$46,320</h2>
                <figure style={{ backgroundColor: "#08C3A5" }}>
                  <AttachMoneyOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <p>Total Revenue <strong style={{ color: "#08C3A5" }}>+ 12%</strong></p>

              <div className="ai_insight success">
                <span>3.36% vs last 30 days</span>
              </div>
            </a>

            {/* Subscription Revenue */}
            <a className="cards" style={{ backgroundColor: "#DEEDFD" }}>
              <div className="data_top">
                <h2>$18,620</h2>
                <figure style={{ backgroundColor: "#83aff9" }}>
                  <AccountBalanceWalletOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <p>Subscription Revenue</p>

              <div className="ai_insight success">
                <span>8.0% + 8.0% vs last 30 days</span>
              </div>
            </a>

            {/* Commission Earnings */}
            <a className="cards" style={{ backgroundColor: "#FEE0C6" }}>
              <div className="data_top">
                <h2>$16,200</h2>
                <figure style={{ backgroundColor: "#ED9A4D" }}>
                  <PercentOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <p>Commission Earnings</p>

              <div className="ai_insight neutral" style={{ color: "#ED9A4D" }}>
                <span>16.7% Projected Next 30 days</span>
              </div>
            </a>

            {/* Platform Fees */}
            <a className="cards" style={{ backgroundColor: "#F3ECFB" }}>
              <div className="data_top">
                <h2>$11,500</h2>
                <figure style={{ backgroundColor: "#9B87EA" }}>
                  <HistoryOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <p>Platform Fees</p>

              <div className="ai_insight success" style={{ color: "#9B87EA" }}>
                <span>22% vs last 300 days</span>
              </div>
            </a>
          </div>
        </div>

        <div className="table_flex w_100 mb_20">
          <div className="lt">

            <div className="cards ">
              <div className="cards_header ">
                <div className="left_s">
                  <h2>Revenue Trends <span className="growth" style={{ color: "#22c55e", fontSize: "14px", marginLeft: "10px" }}>▲ 16% <small style={{ color: "#6b7280" }}>growth</small></span></h2>
                </div>

                <div className="right_s">
                
                </div>
              </div>
              <div className="gap_m">
                <div className="w_100">
                  <Box height={260}>
                    <ResponsiveContainer width="100%" height="100%">
                      <AreaChart data={performanceData}>
                        <defs>
                          <linearGradient id="teal" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#22c55e" stopOpacity={0.5} />
                            <stop offset="100%" stopColor="#22c55e" stopOpacity={0} />
                          </linearGradient>

                          <linearGradient id="blue" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#3b82f6" stopOpacity={0.4} />
                            <stop offset="100%" stopColor="#3b82f6" stopOpacity={0} />
                          </linearGradient>

                          <linearGradient id="orange" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#f59e0b" stopOpacity={0.4} />
                            <stop offset="100%" stopColor="#f59e0b" stopOpacity={0} />
                          </linearGradient>
                        </defs>


                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="name" />
                        <YAxis tickFormatter={(v) => `$${v.toLocaleString()}`} />
                        <Tooltip />


                        <Area
                          type="monotone"
                          dataKey="a"
                          stroke="#22c55e"
                          fill="url(#teal)"
                          strokeWidth={2} />

                        <Area
                          type="monotone"
                          dataKey="b"
                          stroke="#3b82f6"
                          fill="url(#blue)"
                          strokeWidth={2} />

                        <Area
                          type="monotone"
                          dataKey="c"
                          stroke="#f59e0b"
                          fill="url(#orange)"
                          strokeWidth={2} />

                      </AreaChart>
                    </ResponsiveContainer>
                  </Box>
                  <div className="ai-kpi-bar revenue-trends-legend" style={{ display: "flex", gap: "20px", alignItems: "center", marginTop: "20px", padding: "10px", backgroundColor: "#f9fafb", borderRadius: "8px" }}>
                    <div className="kpi-item" style={{ display: "flex", alignItems: "center", gap: "5px", color: "#6b7280", fontSize: "14px" }}>
                      <CalendarTodayOutlinedIcon sx={{ fontSize: 16 }} />
                      <p style={{ margin: 0 }}>Predict Revenue</p>
                    </div>
                    <div className="kpi-item" style={{ display: "flex", alignItems: "center", gap: "5px", color: "#6b7280", fontSize: "14px" }}>
                      <TrendingUpIcon sx={{ fontSize: 16 }} />
                      <p style={{ margin: 0 }}>2.2%</p>
                    </div>
                    <div className="kpi-item" style={{ display: "flex", alignItems: "center", gap: "5px", color: "#6b7280", fontSize: "14px" }}>
                      <span className="dot" style={{ backgroundColor: "#22c55e", width: "8px", height: "8px", borderRadius: "50%" }}></span>
                      <p style={{ margin: 0 }}>Revenue</p>
                    </div>
                    <div className="kpi-item" style={{ display: "flex", alignItems: "center", gap: "5px", color: "#6b7280", fontSize: "14px" }}>
                      <TuneOutlinedIcon sx={{ fontSize: 16 }} />
                      <p style={{ margin: 0 }}>35,989</p>
                      <ChevronDownIcon sx={{ fontSize: 16 }} />
                    </div>
                    <div className="kpi-item" style={{ display: "flex", alignItems: "center", gap: "5px", color: "#6b7280", fontSize: "14px" }}>
                      <PercentOutlinedIcon sx={{ fontSize: 16 }} />
                      <p style={{ margin: 0 }}>25%</p>
                    </div>
                  </div>


                </div>

              </div>
            </div>
            <div className="cards mt_20 revenue_by_plan_card">
              <div className="cards_header">
                <div className="left_s">
                  <h2>Revenue by Plan <span className="growth_badge">▲ 16% growth</span></h2>
                </div>
                <div className="right_s">
                  <div className="header_badges">
                    <span className="badge green">$3,560 - net revenue</span>
                    <span className="badge yellow">$29,382 total report</span>
                  </div>
                
                </div>
              </div>

              <div className="revenue_plan_grid">
                {/* Column 1: Donut Chart & Legend */}
                <div className="chart_col">
                  <Box height={180} position="relative">
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={planChartData}
                          dataKey="value"
                          cx="50%"
                          cy="50%"
                          innerRadius={60}
                          outerRadius={80}
                          startAngle={90}
                          endAngle={-270}
                          paddingAngle={2}
                          stroke="none"
                        >
                          {planChartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                    <Box className="chart_center_text">
                      <p>63%</p>
                      <p>46%</p>
                    </Box>
                  </Box>
                  <div className="chart_legend">
                    <div className="legend_item">
                      <span className="dot basic"></span> Basic Plan
                    </div>
                    <div className="legend_item">
                      <span className="dot standard"></span> Standard Plan
                    </div>
                    <div className="legend_item">
                      <span className="dot premium"></span> Premium Plan
                    </div>
                  </div>
                </div>

                {/* Column 2: Plan Pricing List */}
                <div className="pricing_list_col">
                  <div className="pricing_card">
                    <div className="pricing_row">
                      <div className="label">
                        <span className="dot basic"></span> Basic Plan
                      </div>
                      <div className="value">$3,100</div>
                    </div>
                    <div className="pricing_row">
                      <div className="label">
                        <span className="dot standard"></span> Standard Plan
                      </div>
                      <div className="value">$5,600</div>
                    </div>
                    <div className="pricing_row has_tooltip">
                      <div className="label">
                        <span className="dot premium"></span> Premium Plan
                      </div>
                      <div className="value">$2,200</div>
                      <div className="plan_tooltip">
                        <p>High Churnrisk. - 0%</p>
                        <p>Churn · Projection of Revenue</p>
                        <p>12% of recent days</p>
                      </div>
                    </div>
                    <div className="pricing_row net_revenue_row">
                      <div className="label">
                        <span className="dot revenue"></span> Net Revenue
                      </div>
                      <div className="value">$4,920</div>
                    </div>
                    <div className="total_row">
                      <div className="label">Total</div>
                   
                      <div className="value">$44.5K</div>
                    </div>
                  </div>
                </div>

                {/* Column 3: Revenue Summary List */}
                <div className="summary_list_col">
                  <div className="summary_item">
                    <span>Subscription Revenue</span>
                    <div className="val_group">
                      <strong>$18,620</strong>
                      <span className="growth_up">▲ (+8.0%)</span>
                    </div>
                  </div>
                  <div className="summary_item">
                    <span>Commission Earnings</span>
                    <div className="val_group">
                      <strong>$16,200</strong>
                      <span className="growth_up">▲ (+10.5%)</span>
                    </div>
                  </div>
                  <div className="summary_item">
                    <span>Platform Fees</span>
                    <div className="val_group">
                      <strong>$11,500</strong>
                      <span className="growth_up">▲ (+11.2%)</span>
                    </div>
                  </div>
                  <div className="summary_item">
                    <span>Discounts Given</span>
                    <div className="val_group">
                      <strong>-$1,500</strong>
                      <span className="growth_down">▼ (-10.7%)</span>
                    </div>
                  </div>
                  <div className="summary_item highlighted">
                    <span>Net Revenue</span>
                    <div className="val_group">
                      <strong>$44,820</strong>
                      <span className="growth_up">▲ (+16%)</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bottom Metrics Bar */}
              <div className="revenue_bottom_bar">
                <div className="metric_item">
                  <span className="val green">72%</span>
                  <span className="lbl">Average Fees</span>
                </div>
                <div className="metric_item">
                  <span className="val">$4,320</span>
                  <span className="lbl">Revenue Forecast Missed</span>
                </div>
                <div className="metric_item">
                  <span className="val urgent"><TrendingUpIcon sx={{ fontSize: 18 }} /> 17</span>
                  <span className="lbl">At-Risk Vendors</span>
                </div>
                <div className="metric_item total_revenue">
                  <span className="val">$ 1.54M</span>
                  <span className="lbl">Revenue <i className="icon-chevron-right"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div className="rt">
            <div className="ai_panel">
              <h4>AI Insights</h4>

              <div className="ai_alert warning">
                <span className="icon">⚠️</span>
                <p>
                  <b>7 SKUs</b> need immediate attention
                </p>
              </div>

              <div className="ai_alert danger">
                <span className="icon">⛔</span>
                <p>
                  <b>3 SKUs</b> have zero sales in 30 days
                </p>
              </div>

              <small className="ai_update">
                Next updated ETA: <b>May 5, 2024</b>
              </small>

              <div className="ai_sku_list">
                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_002</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>

                <div className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>#PRD_010</h5>
                    <p>Likely to go out of stock by May</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>
              </div>

              {/* <div className="ai_create">
                                            + Create AI Insights
                                        </div> */}
            </div>

            {/* Revenue Overview Mini Card */}
            <div className="cards revenue_overview_card mt_20">
              <div className="cards_header">
                <div className="left_s">
                  <h2>Revenue Overview</h2>
                </div>
              </div>

              <div className="overview_chart_container">
                <Box height={150} position="relative">
                  <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={performanceData}>
                      <defs>
                        <linearGradient id="miniTeal" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#22c55e" stopOpacity={0.3} />
                          <stop offset="100%" stopColor="#22c55e" stopOpacity={0} />
                        </linearGradient>
                      </defs>
                      <Area
                        type="monotone"
                        dataKey="a"
                        stroke="#22c55e"
                        fill="url(#miniTeal)"
                        strokeWidth={2}
                      />
                      <Area
                        type="monotone"
                        dataKey="b"
                        stroke="#3b82f6"
                        fill="none"
                        strokeWidth={1.5}
                        strokeDasharray="5 5"
                      />
                      <Area
                        type="monotone"
                        dataKey="c"
                        stroke="#f59e0b"
                        fill="none"
                        strokeWidth={1.5}
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                  <div className="chart_growth_overlay">
                    <span>↑ 44.35%</span>
                    <small>↑ 6.9%</small>
                  </div>
                </Box>
              </div>

              <div className="overview_labels">
                <span>Apr 26</span>
                <span>May 15</span>
                <span>May 19</span>
                <span>May 25</span>
                <span>May 21</span>
              </div>

              <div className="badge_row">
                <span className="mini_badge green">▲ +9.5%</span>
                <span className="mini_badge yellow">▲ 111%</span>
                <span className="mini_badge blue">▲ 111.2%</span>
                <span className="mini_badge red">▼ 3,116</span>
                <span className="mini_badge purple">✧ 12.5%</span>
              </div>

              <div className="metric_values">
                <span>$10.5K</span>
                <span>435</span>
                <span>55.8%</span>
                <span>42.32%</span>
                <span>40.30%</span>
              </div>
            </div>
          </div>
        </div>


      </div></>
  );
}
